export type VerdictPillTone =
  | "go-now"
  | "go-later"
  | "go-elsewhere"
  | "not-today"
  | "done-today";

export type VerdictPillProps = {
  tone: VerdictPillTone;
  size?: "sm" | "lg";
};

const TONE_STYLES: Record<VerdictPillTone, string> = {
  "go-now": "border-emerald-500 bg-emerald-600 text-white",
  "go-later": "border-gold bg-gold text-navy",
  "go-elsewhere": "border-sky-500 bg-sky-500 text-white",
  "not-today": "border-slate-300 bg-white text-slate-700",
  "done-today": "border-gold/70 bg-slate-50 text-slate-700",
};

const LABELS: Record<VerdictPillTone, string> = {
  "go-now": "Go now",
  "go-later": "Go later",
  "go-elsewhere": "Go elsewhere",
  "not-today": "Not today",
  "done-today": "Done for today",
};

const SIZE_STYLES: Record<NonNullable<VerdictPillProps["size"]>, string> = {
  sm: "min-h-[28px] px-3 py-1 text-[12px]",
  lg: "min-h-[36px] px-4 py-1.5 text-[14px]",
};

export function VerdictPill({ tone, size = "sm" }: VerdictPillProps) {
  return (
    <span
      className={[
        "inline-flex items-center justify-center rounded-full border font-semibold",
        SIZE_STYLES[size],
        TONE_STYLES[tone],
      ].join(" ")}
    >
      {LABELS[tone]}
    </span>
  );
}
